import React, { Component } from 'react';
import Tree, { TreeNode } from 'rc-tree';
// import { getCurrentLanguage } from '../../../components/Language/languageSettings';
import t from "../Language/language";
import * as languageSettings from "../Language/languageSettings";
import { getStoreDisplayName } from './helpers/formatting';

const language = languageSettings.getCurrentLanguage();
class SelectStores extends Component {
  loop(data, parent) {
    return data.map((item) => {
      if (item.Stores) {
        return (
            <TreeNode
              className='SelectStores-BoldGroupName'
              key={item.StoreUID || item.GroupID}
              title={item.GroupName}
              groupId={parent || item.GroupID}
              isLeaf={!!(item.StoreUID)}
            >
              {this.loop(item.Stores, item.GroupID)}
            </TreeNode>
        );
      }
      if(!item.disabled){
        return (
          <TreeNode
            className='myCls'
            type="store"
            isLeaf={!!item.StoreUID}
            key={item.StoreUID || item.GroupID}
            storeId={item.StoreUID}
            groupId={parent || item.GroupID}
            StoreNumber={item.StoreNumber}
            StoreName={item.StoreName}
            title={getStoreDisplayName(item)}
            disabled={item.disabled}
          />
        );
      }
    });
  }

   render() {
    const { checkedStores } = this.props;
    return (
      <div className="col-xs-12 col-sm-12 col-md-5">
        <b>{this.props.title}</b>
        <div>
          <div className="storeAssignment">
            <Tree
              showIcon={false}
              showLine= {true}
              checkable
              selectable={false}
              defaultExpandAll
              onExpand={this.onExpand}
              checkedKeys={checkedStores}
              onCheck={(checkedKeys) => {
                this.props.setCheckedStores(checkedKeys);
              }}
            >
              {this.loop(this.props.data)}
            </Tree>
           </div>
         </div>
       </div>
    );
  }
}

export default SelectStores


// WEBPACK FOOTER //
// ./src/components/LeaderBoard/SelectStoresSection.js